var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"media":"(max-width: 750px)","srcset":_vm.mobileBackground}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.background,"loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }